import mutations from './mutations.js';
import actions from './actions.js';
import getters from './getters.js';

export default {
    namespaced: true,
    state() {
        return {
            currentLanguage: 'en', // Default to English
            availableLanguages: [
                { code: 'en', flag: '🇬🇧' },
                { code: 'es', flag: '🇪🇸' },
                { code: 'mt', flag: '🇲🇹' }
            ]
        };
    },
    mutations,
    actions,
    getters,
}

